import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;

  & > div:last-child {
    .ant-btn-dangerous {
      background: none;
      color: ${({ theme }) => theme.colors.tone.red};
    }
  }

  .ant-form-item {
    min-width: 288px;
  }
`;
